<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-bridge">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-7">
                <h1 class="display-3 text-white">{{ $t('nav.relations.title') }}</h1>
                <p class="lead  text-white">{{ $t('nav.relations.header') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">{{ $t('relations.clients.title') }}</h2>
            <p class="lead text-muted">{{ $t('relations.clients.para1') }}</p>
          </div>
        </div>
        <div v-for="clientGroup in groupedClients" v-bind:key="clientGroup.id"
             class="row row-grid">
          <div v-for="client in clientGroup" v-bind:key="client.id"
               class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a :href="'/relation/'+client.slug">
                <img v-lazy="client.src"
                     class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                     style="width: 200px;">
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">{{ client.title }}</span>
                  </h5>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">{{ $t('relations.employers.title') }}</h2>
            <p class="lead text-muted">{{ $t('relations.employers.para1') }}</p>
          </div>
        </div>
        <div v-for="employerGroup in groupedEmployers" v-bind:key="employerGroup.id"
             class="row row-grid">
          <div v-for="employer in employerGroup" v-bind:key="employer.id"
               class="col-md-6 col-lg-3 mb-5 mb-lg-0">
            <div class="px-4">
              <a :href="'/relation/'+employer.slug">
                <img v-lazy="employer.src"
                     class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                     style="width: 200px;">
                <div class="pt-4 text-center">
                  <h5 class="title">
                    <span class="d-block mb-1">{{ employer.title }}</span>
                  </h5>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import clientData from '../data/clients.js';
  import employerData from '../data/employers';
  import listUtils from "../lib/listUtils";

  export default {
    name: "clients",
    components: {},
    data() {
      return {
        clients: clientData,
        employers: employerData
      }
    },
    computed: {
      groupedClients() {
        return listUtils.group(listUtils.sortById(this.clients))
      },
      groupedEmployers() {
        return listUtils.group(listUtils.sortById(this.employers))
      }
    }
  };
</script>
